/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.contact_imports.init());


App.contact_imports = {

  init() {
    App.unsubscribe("superadmin.contact_imports.updated", this.updated);
    App.subscribe("superadmin.contact_imports.updated", this.updated);

    if ($('.js-public-contact-import-form').length) {
      return $(document)
        .off("click", ".js-import-acks", App.contact_imports.ack_clicked)
        .on("click", ".js-import-acks", App.contact_imports.ack_clicked);
    }
  },


  ack_clicked(evt) {
    const $checked = $(".js-import-acks:checked");
    return $(".js-contact-import-submit").prop("disabled", $checked.length !== 2);
  },


  updated(evt) {
    const {
      contact_import
    } = evt.detail;
    const $row = $(`[data-type=ContactImport][data-id=${contact_import.id}]`);

    if (!$row.length) { return; }

    $row.find(".js-contact-import-count").text(contact_import.contact_count);
    $row.find(".js-contact-import-status").text(contact_import.status);

    const percentage = contact_import.percent_complete.toFixed(0);
    const $progress = $row.find(".progress-bar");
    return $progress
      .attr("aria-valuenow", percentage)
      .css({width: `${percentage}%`})
      .text(`${percentage}%`);
  }
};
